import { useAuthStatus, useUserInitializationContext } from '@/features/user'
import { useCrypto } from '@/infra/crypto'
import { useSessionHydration } from './api'

export function SessionHydrator() {
  const { isAuthenticated, user } = useAuthStatus()
  const { userInitialized } = useUserInitializationContext()
  const { isReady: cryptoReady } = useCrypto()

  const enabled = isAuthenticated && userInitialized && !!user?.access_token && cryptoReady

  useSessionHydration({ enabled })

  return null
}
